import { Container } from 'theme-ui';

import { withInView } from '@utils';
import { Section } from '@snippets';

import { Schema } from './TwoTile.schema';
import { GridDisplay } from './GridDisplay';
import { Header, Footer } from './Content';

export const TwoTile = withInView(
  ({ cms }) => {
    const { section, header, tiles, tile } = cms;

    return (
      <Section section={section}>
        <Container data-comp={TwoTile.displayName}>
          <Header header={header} section={section} />

          <GridDisplay tiles={tiles} tile={tile} />

          <Footer header={header} section={section} />
        </Container>
      </Section>
    );
  },
  { triggerOnce: true }
);

TwoTile.displayName = 'TwoTile';
TwoTile.Schema = Schema;
